import { RootState } from 'MyTypes';

import { RouterState } from './reducer';

export const getRouter = (state: RootState): RouterState => state.router;
